export default __webpack_public_path__ + "static/media/animas_IR.60fbec93.png";